import moment from "moment";

import { DATE_FORMAT_ISO, LOCALE } from "../../thor.const";

export class DateService {
    public format(date: Date): string {
        return date ? moment(date).format(DATE_FORMAT_ISO) : null;
    }

    /**
     * Get days interval between 2 dates
     * if value is not declared, it will return now
     * @param from
     * @param to
     * @return number, as days
     */
    public getDiffDays(
        { fromDate, toDate }: { fromDate: Date | string; toDate: Date | string } = { fromDate: null, toDate: null }
    ): number {
        return moment(fromDate).diff(moment(toDate), "days");
    }

    public getIntlDate(date: Date, { locale = moment.locale() || LOCALE, format }) {
        return new Intl.DateTimeFormat(locale, format).format(date);
    }

    public setDateToDuration(fromDate: Date, toDate: Date): string {
        if (!fromDate || !toDate || fromDate === toDate) {
            return null;
        }
        const duration = moment.duration(moment(fromDate).diff(moment(toDate)));
        return duration.toISOString();
    }

    public setDurationToDate(fromDate: Date, duration: string): Date {
        if (!fromDate || !duration) {
            return null;
        }
        return moment(fromDate).subtract(moment.duration(duration)).toDate();
    }

    public toDate(date: string) {
        return date ? moment(date).toDate() : null;
    }
}

angular.module("thor.core.dates.date.service", []).service("dateService", DateService);
